export default __webpack_public_path__ + "static/media/mail-active.746b73a7.svg";